module.exports = __webpack_public_path__ + "assets/icon-celebration-component.83b26aaa.svg";